import { isMobileLayout } from '../../../components/styles/responsive';
import { AbstractPathResolver, PathResolveResult } from '../PathResolver';

export class StoreFrontPathResolver extends AbstractPathResolver {
  resolveStateFromPath(): PathResolveResult {
    const { path } = this.context;

    if (path.startsWith('/storefront')) {
      const defaultState = this.getDefaultState();

      const route = (defaultState?.routes[1] ?? defaultState?.routes[0])?.state
        ?.routes[0];

      const routeName = route?.name ?? 'main';
      const routeState = route?.state;
      const routeParams = route?.params;

      let index = 0;

      const routes = [
        {
          name: routeName,
          state: routeState,
          params: routeParams,
        },
      ];

      if (routeName !== 'main') {
        routes.unshift({ name: 'main', state: undefined, params: {} });
        index = 1;
      }

      if (isMobileLayout()) {
        return {
          routes: [
            {
              name: 'home',
              state: {
                routes: [
                  {
                    name: 'user',
                    state: {
                      index,
                      routes,
                    },
                    params: {
                      alias: 'storefront',
                    },
                  },
                ],
              },
            },
          ],
        };
      } else {
        let topIndex = 0;
        const topRoutes: any[] = [
          {
            name: 'storefront',
            state: {
              index,
              routes,
            },
          },
        ];
        // for psl, always render the home page.
        topRoutes.unshift({ name: 'home', state: undefined });
        topIndex = 1;
        return {
          index: topIndex,
          routes: topRoutes,
        };
      }
    }
  }
}
